import AsyncBlogCarousel from 'Src/js/components/carousels/AsyncBlogCarousel.vue';
import BlogCarousel from 'Src/js/components/carousels/BlogCarousel.vue';
import Vue from "vue";
import { CarouselQuery, PostQuery } from "JS/services/BlogService";

// NOTE: This is likely depricated now and we will be moving to the new "async" style carousel over time.
export function initializeBlogCarousel(selector: string, props: {
	title: string;
	smallTitle?: string;
	viewAllLink: string,
	viewAllLinkAssistiveText: string,
	query: PostQuery
}): void {

	if (props.smallTitle == null) {
		props.smallTitle = props.title;
	}

	const blogCarousel: HTMLElement | undefined = document.querySelector(selector);
	if (blogCarousel) {
		new Vue({
			el: blogCarousel,
			render: h => h(BlogCarousel, {
				props,
			}),
		});
	}
}

export function initializeAsyncBlogCarousel(selector: string, props: {
	heading: string;
	query: CarouselQuery;
	viewAllLink?: string;
}): void {

	const blogCarousel: HTMLElement | undefined = document.querySelector(selector);
	if (blogCarousel) {
		new Vue({
			el: blogCarousel,
			render: h => h(AsyncBlogCarousel, {
				props,
			}),
		});
	}
}

